import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { StorageService } from '../services/storage/storage.service';
import { APP_ROUTES } from '../../app.routes.model';

export const orgAuthGuard: CanActivateFn = () => {
  const router = inject(Router);
  const isOrgUser = !inject(StorageService).isHdUser$$(); // org user currently means NOT HD user

  if (isOrgUser) {
    return true;
  }

  // Redirect to the login page
  return router.navigate([APP_ROUTES.hdZone]);
};
